<template>
  <!-- 发件人地址库弹框  -->
  <div class="dialogBox">
    <el-dialog title="Print label" :visible.sync="dialogTableVisible" @close="clkCloseBtn" :close-on-click-modal="false" custom-class="borRad10" width="500px">
      <div style="padding-left: 10px">
        <table border="0" cellspacing="0" cellpadding="0" class="Table">
          <tr>
            <th width="26%" align="right" class="veTop2" style="top: 11px">
              <p>Quantity of order:&nbsp;</p>
            </th>
            <td align="left">
              <input type="text" style="width: 220px" class="inputLine" :class="{ borRed: IsQty }" v-model="orderQuantity" placeholder="" />
              <p class="colRed" v-show="IsQty">Required</p>
            </td>
          </tr>
          <tr>
            <th width="20%" align="right">
              <p>Print paper:&nbsp;</p>
            </th>
            <td align="left">
              <el-radio v-model="radioSet" :label="1" @change="chgRad">A4 paper</el-radio>
              <el-radio v-model="radioSet" :label="2" @change="chgRad">Thermal paper（100*100mm）</el-radio>
            </td>
          </tr>
        </table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="clkClose">Cancel</el-button>
        <el-button type="primary" @click="insurBoxBtn">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import { getCookie } from '../../../ask/cookiejs'
import { post, fetch, Del, put } from '../../../ask/axios'
import { fileSteamDownload } from '@/utils/download'
// import bus from '../../../ask/eventBus'
export default {
  //// 接受父组件的值
  props: {
    orderNoEnven: String,
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      //收发件人信息
      dialogTableVisible: false,

      orderQuantity: null,
      radioSet: 1,//
      radioSetB: null,//

      IsQty: false,
    }
  },

  created() { //创建后

  },
  mounted() { //载入dom后周期函数


  },
  watch: {//监听函数变化

  },
  computed: {//计算属性

  },

  //方法
  methods: {
    //-------------------------------收发件人，通知人信息---------------------------------//
    //
    clkDialog(Qty) {
      this.radioSetB = 1
      this.orderQuantity = Qty
      this.dialogTableVisible = true
    },

    //打印预览
    insurBoxBtn() {
      // console.log('sdsd3333   ' + JSON.stringify(item))
      if (!this.orderQuantity) {
        this.IsQty = true
        return false
      }
      this.PrintQtyAPI(),
        this.dialogTableVisible = false;
    },
    clkCloseBtn() {
      this.orderQuantity = null
      this.radioSet = 1
      this.IsQty = false
    },
    clkClose() {
      this.orderQuantity = null
      this.IsQty = false
      this.radioSet = 1
      this.dialogTableVisible = false;
    },
    //调用件数修改接口
    PrintQtyAPI() {
      let that = this;
      // that.api.param = {
      //     // Quanlity: this.orderQuantity,
      //     // waybillNO: this.orderNoEnven,
      //   };
      that.api.url = this.$api04 + "/Air/api/AirOrder/UpdateAirQuanlity?waybillNO=" + this.orderNoEnven + '&Quanlity=' + this.orderQuantity;
      post(that.api.url).then(function (res) {
        if (res.Results == true) {
          that.PrintLabelAPI()
          //  that.radioSetB=JSON.stringify(that.radioSet)
          //  console.log('radioSetBt2: ' +  that.radioSetB)
          that.$emit('printMsgEvent', true)
        } else {
          that.$emit('printMsgEvent', false)
        }
      })
    },
    chgRad() {
      //console.log('this.radioSet: ' +  this.radioSet)
      this.radioSetB = JSON.stringify(this.radioSet)
      // console.log('radioSetBt1: ' +  this.radioSetB)
    },
    //打印标签
    PrintLabelAPI() {
      let that = this;
      //     console.log('radioSet: ' +  this.radioSet)
      //  // console.log('this.radioSetB: ' +  this.radioSetB)
      if (this.radioSetB == 1) {
        var width = 210;
        var height = 297;
      } else if (this.radioSetB == 2) {
        var width = 100;
        var height = 100;
      }
      that.api.param = {
        Width: width,
        Height: height,
        WaybillNo: this.orderNoEnven,
        WaybillType: 3, //订单类型(1、快递；2、小包；3、空运；20、fba)
      };
      var prePage = window.open();
      that.api.url = that.$api05 + "/api/Make/PDFLable";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.ResultCode == 1) {
          prePage.location.href = res.Data
          // let url = res.Data
          // let name = url.split('/')[url.split('/').length - 1]
          // fileSteamDownload(that, {
          //   FullPath: url, // 路径
          //   CurrentFileName: name // 文件名称
          // }, name);
          // location.href = that.$apiFileCloud + (url.indexOf('/') === 0 ? '' : '/') + url
          that.dialogTableVisible = false;
        } else {
          prePage.close()
          that.dialogTableVisible = false;
          that.$confirm('failed!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false

        }
      })
    },
  },


}
</script>

<style type="text/css" rel="stylesheet" scoped="scoped">
.Table {
  width: 100%;
  font-size: 14px;
}
.Table tr th {
  font-size: 12px;
  color: #000;
}
.Table tr td {
  font-size: 12px;
  color: #444;
  padding: 5px 0;
  line-height: 20px;
  word-break: break-all;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/printlabelBox.vue